var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.424 9.614h-.89a2.003 2.003 0 0 0 0 4.006h.89a2.003 2.003 0 1 0 0-4.006Z",
    stroke: "#1E5DFF",
    strokeWidth: 1.669
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41 5.832h2.671c1.717 0 2.87.002 3.73.118.821.11 1.173.301 1.405.533.232.232.423.584.534 1.406.07.522.098 1.151.11 1.949h1.336C19.164 7.63 19 6.378 18.16 5.539c-1.043-1.043-2.721-1.043-6.079-1.043h-2.67c-3.358 0-5.037 0-6.08 1.043-1.043 1.043-1.043 2.722-1.043 6.08 0 3.357 0 5.036 1.043 6.079 1.043 1.043 2.722 1.043 6.08 1.043h2.67c3.358 0 5.037 0 6.08-1.043.84-.84 1.003-2.091 1.035-4.3H17.86c-.012.799-.04 1.428-.11 1.95-.11.822-.302 1.173-.534 1.405-.232.232-.584.423-1.405.534-.86.115-2.013.118-3.73.118h-2.67c-1.717 0-2.87-.003-3.73-.118-.822-.11-1.174-.302-1.406-.534-.232-.232-.423-.583-.533-1.405-.116-.86-.118-2.013-.118-3.73 0-1.716.002-2.87.118-3.73.11-.82.301-1.173.533-1.405.232-.232.584-.423 1.406-.533.86-.116 2.013-.118 3.73-.118Z",
    fill: "#1E5DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.518 9.17h4.896",
    stroke: "#1E5DFF",
    strokeWidth: 1.669,
    strokeLinecap: "round"
  })));
};
export default SvgWallet;